module.exports = require("./../../_gen/starling/textures/TextureAtlas");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/textures/TextureAtlas.js
// module id = 238
// module chunks = 0